export default {
      id: "BTC-usage",
      viewBox: "0 0 12.7 16.7",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#BTC",
      toString: function () {
        return this.url;
      }
    }